import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('jStoreAutomation', ['pausePanZoom', 'resumePanZoom']),
  },

  methods: {
    pauseZoom() {
      this.pausePanZoom();
    },

    resumeZoom() {
      this.resumePanZoom();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/visual-programming/jMixPanZoom.js